import React from "react";
import Checkbox from "../../../components/Checkbox";

const FormInputs = (props) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.generateReport();
      }}
    >
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Linhagem</label>
            <select
              className="form-control form-control-sm"
              value={props.inputs.lineage}
              onChange={(event) => props.inputHandler(-1, "lineage", event)}
            >
              <option value="">Selecione a Linhagem</option>
              <option value="rossMale">Ross Macho</option>
              <option value="cobbMale">Cobb Macho</option>
              <option value="hubbardMale">Hubbard Macho</option>
              <option value="rossFemale">Ross Fêmea</option>
              <option value="cobbFemale">Cobb Fêmea</option>
              <option value="hubbardFemale">Hubbard Fêmea</option>I
            </select>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group mt-3">
            <div className="form-check">
              <Checkbox
                label="Utilizar Consumo de ração Observado"
                checked={props.inputs.useFi}
                onChange={(checked) => props.checkboxHandler(checked, "useFi")}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group mt-3">
            <div className="form-check">
              <Checkbox
                label="Utilizar Peso Vivo Observado"
                checked={props.inputs.useBw}
                onChange={(checked) => props.checkboxHandler(checked, "useBw")}
              />
            </div>
          </div>
        </div>
      </div>
      <table className="table">
        <thead className="thead-dark form-inputs-postura__header">
          <tr>
            <th
              className="col form-inputs-postura__header--fixed text-center"
              colSpan="3"
            >
              Programa Nutricional
            </th>
          </tr>
          <tr>
            <th className="col form-inputs-postura__header--fixed">
              Início (dia)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Fim (dia)
            </th>
          </tr>
        </thead>
        <tbody>
          {props.inputs.feedProgram.map((input, indexRow) => (
            <tr key={`row${indexRow}`}>
              {Object.keys(input).map((key, indexColumn) => (
                <td key={`column${indexColumn}`}>
                  <input
                    type="number"
                    className="form-control"
                    placeholder={input[key].label}
                    value={input[key].value}
                    onChange={(event) =>
                      props.inputHandler(indexRow, key, event, "feedProgram")
                    }
                  />
                </td>
              ))}
            </tr>
          ))}
          <tr>
            <td colSpan="8">
              <div className="form-inputs-postura__footer d-flex justify-content-end">
                {props.inputs.feedProgram.length > 1 ? (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm mr-1"
                    onClick={() => props.removeLine("feedProgram")}
                  >
                    Remover linha
                  </button>
                ) : null}
                <button
                  type="button"
                  className="btn btn-info btn-sm"
                  onClick={props.addLineFeedProgram}
                >
                  Adicionar Linha
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table className="table">
        <thead className="thead-dark form-inputs-postura__header">
          <tr>
            <th className="col form-inputs-postura__header--fixed">Dia</th>
            <th className="col form-inputs-postura__header--fixed">
              Temperatura (ºC)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Energia Metabolizável (Mcal/kg)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Peso Vivo (kg/ave)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Consumo de Ração (g/ave)
            </th>
          </tr>
        </thead>
        <tbody>
          {props.inputs.dayData.map((input, indexRow) => (
            <tr key={`row${indexRow}`}>
              {Object.keys(input).map((key, indexColumn) => (
                <td key={`column${indexColumn}`}>
                  <input
                    type="number"
                    className="form-control"
                    placeholder={input[key].label}
                    value={input[key].value}
                    onChange={(event) =>
                      props.inputHandler(indexRow, key, event, "dayData")
                    }
                  />
                </td>
              ))}
            </tr>
          ))}
          <tr>
            <td colSpan="8">
              <div className="form-inputs-postura__footer d-flex justify-content-end">
                {props.inputs.dayData.length > 1 ? (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm mr-1"
                    onClick={() => props.removeLine("dayData")}
                  >
                    Remover linha
                  </button>
                ) : null}
                <button
                  type="button"
                  className="btn btn-info btn-sm"
                  onClick={props.addLineDay}
                >
                  Adicionar Linha
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="row">
        <div className="col-md-12 text-center">
          <button type="submit" className="btn btn-primary btn-sm ">
            Gerar Relatório
          </button>
        </div>
      </div>
    </form>
  );
};

export default FormInputs;
